"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getNumToNearestHundred_1 = __importDefault(require("./getNumToNearestHundred"));
var isNothing_1 = __importDefault(require("./isNothing"));
var getCostString = function (costData) {
    if (costData === void 0) { costData = {}; }
    var costMin = costData.costMin, costMax = costData.costMax;
    if ((0, isNothing_1.default)(costMin))
        return '';
    if (costMin === 0 && !costMax)
        return 'Free';
    var costMinHun = (0, getNumToNearestHundred_1.default)(costMin);
    var costMaxHun = costMax ? (0, getNumToNearestHundred_1.default)(costMax) : null;
    var costMinThous = (costMinHun / 1000) % 1 === 0
        ? (costMinHun / 1000).toFixed(0)
        : (costMinHun / 1000).toFixed(1);
    var costMaxThous = costMaxHun
        ? (costMaxHun / 1000) % 1 === 0
            ? (costMaxHun / 1000).toFixed(0)
            : (costMaxHun / 1000).toFixed(1)
        : null;
    if (!costMax) {
        return "".concat(parseFloat(costMinThous) >= 1 ? "$".concat(costMinThous, "k") : "$".concat(costMinHun));
    }
    var costMinIsOverAThous = parseFloat(costMinThous) >= 1;
    var costMaxIsOverAThous = costMaxThous
        ? parseFloat(costMaxThous) >= 1
        : false;
    var bothOverAThous = costMinIsOverAThous && costMaxIsOverAThous;
    return "".concat(bothOverAThous
        ? "$".concat(costMinThous, "k-$").concat(costMaxThous, "k")
        : "".concat(costMaxIsOverAThous
            ? "$".concat(costMinHun, "-$").concat(costMaxThous, "k")
            : "$".concat(costMinHun, "-$").concat(costMaxHun)));
};
exports.default = getCostString;
